<template>
    <div class="row">
        <div class="col-lg-12 ">
            <div v-if="loading" class="lds-dual-ring"></div>
            <div v-else>
                <div class="box">
                    <div class="box-offset">
                        <div class="box-ttl-wrap">
                            <div class="box-ttl">Return Uniform</div>
                        </div>
                        <div class="form mt-3">
                            <div class="row">
                                <div class="col-md-12">
                                    <p>
                                        <b>
                                            {{ userName }}
                                        </b>
                                    </p>
                                </div>

                                <div class="col-lg-12">
                                    <div class="table-holder table-responsive ">
                                        <table class="table ">
                                            <thead>
                                            <tr>
                                                <th>Inventory Item</th>
                                                <th style="width: 7rem">Size</th>
                                                <th style="width: 6rem">Quantity</th>
                                                <th style="width: 6rem">Returned Quantity</th>
                                                <th style="width: 4rem"></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="request in uniformRequests "
                                                :key="request.id"
                                            >
                                                <td>{{ request.uniform.title }}</td>
                                                <td>
                                                    <div class="form-group form-group-2 mb-0">
                                                        <input
                                                            type="text"
                                                            class="form-control readonly"
                                                            :value="request.size"
                                                            readonly>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-2 mb-0">
                                                        <input
                                                            type="text"
                                                            class="form-control readonly"
                                                            :value="request.quantity"
                                                            readonly
                                                        >
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-2 mb-0">
                                                        <input
                                                            v-if="request.quantity > 0"
                                                            :id="'input_' + request.uniform_id"
                                                            type="number"
                                                            min="0"
                                                            :max="request.quantity"
                                                            class="form-control"
                                                            v-model.number="request.returned_quantity"
                                                            @change="validateQuantity(request.returned_quantity, request)"
                                                        >
                                                        <input
                                                            v-else
                                                            type="text"
                                                            class="form-control readonly"
                                                            value="0"
                                                            readonly
                                                        >
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group form-group-2">
                                        <label for="" class="form-label">Comment</label>
                                        <textarea
                                            type="text"
                                            class="form-control height-2"
                                            v-model="requestReturn.comment"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="btns-wrap">
                                        <a
                                            :href="link"
                                            class="btn btn--outline-primary w-100 w-sm-auto"
                                        >Cancel</a>
                                        <a
                                            class="btn btn--secondary w-100 w-sm-auto"
                                            @click="sendRequest"
                                        >Proceed</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UniformsService from "../../../../Uniforms/resources/js/service/UniformsService";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";

export default {
    name: 'ReturnedUniform',
    mixins: [ModalHandler],
    props: {
        userId: {
            type: Number
        },
        userName: {
            type: String
        },
        link: {
            type: String
        },
    },
    data() {
        return {
            loading: true,
            returned_quantity: null,
            uniformRequests: [],
            requestReturn: {
                uniforms: [{
                    returned_quantity: 0,
                    request_id: null,
                }],
                comment: null,
            },
            filters: {
                search: '',
                page: 1,
                perPage: 30,
                status: "Completed"
            },
        }
    },
    methods: {
        async getListOfApplicantsUniformRequests() {
            try {
                const { data: response } = await UniformsService.getEmployeeListOfRequests(this.userId, this.filters)
                this.uniformRequests = response.data
                this.requestReturn.uniforms = this.uniformRequests.map(uniform => {
                    return {
                        request_id: uniform.id,
                        returned_quantity: 0,
                    }
                });
                this.loading = false
            } catch (e) {
                this.$showErrorMessage('Failed to load the list of requests. Please reload the page');
            }
        },
        validateQuantity(returnedQuantity, request) {
            const foundUniform = this.requestReturn.uniforms.find(u => u.request_id === request.id);
            if (foundUniform) {
                if (returnedQuantity > request.quantity) {
                    request.returned_quantity = 0;
                    foundUniform.returned_quantity = 0;
                    this.$showErrorMessage('The return quantity cannot be greater than the ordered quantity');
                } else if (returnedQuantity < 0) {
                    request.returned_quantity = 0;
                    foundUniform.returned_quantity = 0;
                    this.$showErrorMessage('The return quantity cannot be less than 0');
                } else {
                    request.returned_quantity = returnedQuantity;
                    foundUniform.returned_quantity = returnedQuantity;
                }
            }
        },
        async sendRequest() {
            this.$showLoadingMessage()
            try {
                await UniformsService.sendReturnedUniform(this.requestReturn)
                this.$showSuccessMessage('Item has been added')

                setTimeout(() => {
                    const url = new URL(window.location);
                    url.searchParams.set('tab', 'Uniforms');
                    window.location.href = url.href;
                }, 1000)

            } catch (e) {
                this.$showErrorMessage();
            }
        },
    },
    mounted() {
        this.getListOfApplicantsUniformRequests()
    }


}

</script>


<style scoped>
.readonly {
    background: rgba(226, 231, 241, .54) !important;
}

</style>
